import React from 'react';
import './TimeSlots.css';

const TimeSlots = ({
  selectedDate,
  selectedTime,
  onSelectTime,
  availableSlots,
  isLoading,
  error,
  onRetry
}) => {
  // 1시간 단위 시간 슬롯 정의 (백엔드와 일치, 시술 시간 2시간 블록)
  const allTimeSlots = [
    { value: '10:00', label: '10:00', endTime: '12:00', period: '오전' },
    { value: '11:00', label: '11:00', endTime: '13:00', period: '오전' },
    { value: '12:00', label: '12:00', endTime: '14:00', period: '오후' },
    { value: '13:00', label: '1:00', endTime: '15:00', period: '오후' },
    { value: '14:00', label: '2:00', endTime: '16:00', period: '오후' },
    { value: '15:00', label: '3:00', endTime: '17:00', period: '오후' },
    { value: '16:00', label: '4:00', endTime: '18:00', period: '오후' },
    { value: '17:00', label: '5:00', endTime: '19:00', period: '오후' },
    { value: '18:00', label: '6:00', endTime: '20:00', period: '오후' },
    { value: '19:00', label: '7:00', endTime: '21:00', period: '오후' },
    { value: '20:00', label: '8:00', endTime: '22:00', period: '오후' },
  ];

  // 날짜가 선택되지 않은 경우
  if (!selectedDate) {
    return (
      <div className="time-slots">
        <h4 className="time-slots-title">시간 선택</h4>
        <p className="time-slots-message">먼저 날짜를 선택해주세요.</p>
      </div>
    );
  }

  // 로딩 중
  if (isLoading) {
    return (
      <div className="time-slots">
        <h4 className="time-slots-title">시간 선택</h4>
        <div className="time-slots-loading">
          <div className="loading-spinner"></div>
          <p>예약 가능한 시간을 확인하는 중...</p>
        </div>
      </div>
    );
  }

  // 에러 발생 시
  if (error) {
    return (
      <div className="time-slots">
        <h4 className="time-slots-title">시간 선택</h4>
        <div className="time-slots-error">
          <span className="error-icon">⚠️</span>
          <p>{error}</p>
          {onRetry && (
            <button type="button" className="retry-btn" onClick={onRetry}>
              다시 시도
            </button>
          )}
        </div>
      </div>
    );
  }

  // 예약 가능한 시간이 없는 경우
  if (availableSlots && availableSlots.length === 0) {
    return (
      <div className="time-slots">
        <h4 className="time-slots-title">시간 선택</h4>
        <div className="time-slots-empty">
          <span className="empty-icon">📅</span>
          <p className="empty-title">예약 가능한 시간이 없습니다</p>
          <p className="empty-subtitle">다른 날짜를 선택해주세요.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="time-slots">
      <h4 className="time-slots-title">시간 선택</h4>
      <p className="time-slots-subtitle">
        시술 시간은 약 2시간 소요됩니다
      </p>
      <div className="time-slots-grid">
        {allTimeSlots.map((slot) => {
          const isAvailable = availableSlots ? availableSlots.includes(slot.value) : true;
          const isSelected = selectedTime === slot.value;

          return (
            <button
              key={slot.value}
              type="button"
              className={`time-slot-button ${isSelected ? 'selected' : ''} ${!isAvailable ? 'disabled' : ''}`}
              onClick={() => isAvailable && onSelectTime(slot.value)}
              disabled={!isAvailable}
              aria-label={`${slot.period} ${slot.label} ~ ${slot.endTime} ${isAvailable ? '' : '(예약 마감)'}`}
            >
              <span className="time-slot-period">{slot.period}</span>
              <span className="time-slot-time">{slot.label}</span>
              <span className="time-slot-range">~ {slot.endTime}</span>
              {!isAvailable && (
                <span className="time-slot-badge">마감</span>
              )}
              {isSelected && (
                <span className="time-slot-check">✓</span>
              )}
            </button>
          );
        })}
      </div>

      <div className="time-slots-legend">
        <div className="legend-item">
          <span className="legend-dot available"></span>
          <span>예약 가능</span>
        </div>
        <div className="legend-item">
          <span className="legend-dot unavailable"></span>
          <span>예약 마감</span>
        </div>
      </div>
    </div>
  );
};

export default TimeSlots;
